import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import ExportJobBand from './ExportJobBand';
import ExportEmptyState from './ExportEmptyState';
import './style.css';

const ExportJobsList = ({
  jobs,
  tab,
  onFavoriteClick,
  onRerunClick,
  onCloneClick,
  onRemoveClick,
  onCreateNew,
  t,
}) => {
  if (!jobs.length) {
    return (
      <ExportEmptyState
        tab={tab}
        t={t}
        onCreateNew={onCreateNew}
      />
    );
  }

  return (
    <table className="export-table">
      <thead>
        <tr className="export-table-header">
          <th className="export-table-th">{t('export:name')}</th>
          <th className="export-table-th">{t('export:date')}</th>
          <th className="export-table-th">{t('export:status')}</th>
          <th className="export-table-th export-table-th--actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        {map(jobs, (job) => (
          <ExportJobBand
            key={job.uuid}
            job={job}
            onRerunClick={onRerunClick}
            onCloneClick={onCloneClick}
            onFavoriteClick={onFavoriteClick}
            onRemoveClick={onRemoveClick}
            t={t}
          />
        ))}
      </tbody>
    </table>
  );
};

ExportJobsList.propTypes = {
  jobs: PropTypes.array.isRequired,
  tab: PropTypes.string.isRequired,
  onFavoriteClick: PropTypes.func.isRequired,
  onRerunClick: PropTypes.func.isRequired,
  onCloneClick: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onCreateNew: PropTypes.func,
  t: PropTypes.func.isRequired,
};

ExportJobsList.defaultProps = {
  onCreateNew: null,
};

export default ExportJobsList;
